<template>
  <tbody class="v-table__body">
    <tr class="v-table__row v-table__row--header"
        @click="toggleCollapse"
        v-if="$slots.header"
        :class="[item && item.type && item.type.attribute && item.type.attribute.slug ? 'v-table--colorful appointment-'+item.type.attribute.slug : item?'appointment-default v-table--colorful':'']">
      <slot name="header"></slot>
    </tr>

    <slot :is-collapsed="localIsCollapsed"></slot>
  </tbody>
</template>


<script>
  export default {
    data() {
      return {
        localIsCollapsed: this.isCollapsed
      };
    },
    mounted() {

      document.querySelectorAll('.js-message-respond').forEach(el => {
        el.addEventListener("click", function () {
          el.parentNode.classList.add('active');
        });
      });

      this.$root.$on('saveAndShowFinished', () => {
        document.querySelectorAll('.js-tools-wrap.active').forEach(el => {
          el.querySelector('.js-message-status-reply').style.color = "#23c323";
          el.classList.remove('active');
        });
      });

      this.$root.$on('saveAndCloseFinished', () => {
        document.querySelectorAll('.js-tools-wrap.active').forEach(el => {
          el.querySelector('.js-message-status-reply').style.color = "#23c323";
          el.classList.remove('active');
        });
      });

      this.detectSwipe();
    },
    methods: {
      toggleCollapse() {
        let that = this;
        this.localIsCollapsed = !this.localIsCollapsed;
        if (this.item !== undefined) {
          let row = {
            id: this.item.id,
            isCollapsed: this.localIsCollapsed
          };
          let myStorage = localStorage;
          let storedRows = JSON.parse(
            localStorage.getItem("appointmentsRowStateList")
          );
          if (storedRows === null) {
            storedRows = [];
            storedRows.push(row);
          } else {
            let storedRow = storedRows.find(obj => obj.id == that.item.id);
            if (storedRow) {
              storedRow.isCollapsed = that.localIsCollapsed;
            } else {
              storedRows.push(row);
            }
          }
          myStorage.setItem(
            "appointmentsRowStateList",
            JSON.stringify(storedRows)
          );
        }
      },
      detectSwipe() {
        let selector = this.$el.closest('.table-responsive-wrap');

        if (!selector) {
          return;
        }

        selector.addEventListener('touchstart', handleTouchStart, false);
        selector.addEventListener('touchmove', handleTouchMove, false);

        let xDown = null,
          yDown = null;

        function getTouches(event) {
          return event.touches || // browser API
            event.originalEvent.touches; // jQuery
        }

        function handleTouchStart(event) {
          const firstTouch = getTouches(event)[0];
          xDown = firstTouch.clientX;
          yDown = firstTouch.clientY;
        };

        function handleTouchMove(event) {
          if (!xDown || !yDown) {
            return;
          }

          let xUp = event.touches[0].clientX,
            yUp = event.touches[0].clientY,
            xDiff = xDown - xUp,
            yDiff = yDown - yUp;



          if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0 || xDiff < 0) {
              selector.style.overflowX = "auto"; /* left or right swipe */
            }
          } else {
            if (yDiff > 0 || yDiff < 0) {
              selector.style.overflowX = "hidden"; /* up or down swipe */
            }
          }

          /* reset values */
          xDown = null;
          yDown = null;
        }
      }
    },
    props: {
      item: {
        type: Object
      },
      isCollapsed: {
        default: true,
        type: Boolean
      }
    }
  };
</script>